import { render, staticRenderFns } from "./FollowUpFields.vue?vue&type=template&id=7210fc47&scoped=true"
import script from "./FollowUpFields.vue?vue&type=script&lang=js"
export * from "./FollowUpFields.vue?vue&type=script&lang=js"
import style0 from "./FollowUpFields.vue?vue&type=style&index=0&id=7210fc47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210fc47",
  null
  
)

export default component.exports